import { Link, useLocation } from "react-router-dom";
import { PiCaretDownBold } from "react-icons/pi";
import { tenantPath } from "@/lib/tenant";
import { NAV } from "../navigation/merchantCatalog";
import { filterMerchantItems } from "../navigation/access";
import { activeNavigationItem } from "../navigation/activeItem";
import useSidebarScroll from "../hooks/useSidebarScroll";

export default function MerchantNavigation({ role, modules, features, permissions, dealerCapabilities, pageUser, collapsed, toggle, scrollScope }) {
  const { pathname } = useLocation();
  const groups = NAV.map(group => ({ ...group, items: filterMerchantItems(group.items, role, modules, features, permissions, dealerCapabilities, pageUser) }));
  const active = activeNavigationItem(groups, pathname, tenantPath);
  const scroll = useSidebarScroll(scrollScope, `${pathname}:${active || ""}`);
  return (
    <nav {...scroll} aria-label="Main navigation" className="flex-1 py-2 overflow-y-auto thin-scroll">
      {groups.map((group, gi) => {
        const items = group.items;
        if (items.length === 0) return null;
        const isCollapsed = group.section && collapsed[group.section];
        return (
          <div key={gi} className="mb-1">
            {group.section && (
              <button
                onClick={() => toggle(group.section)}
                data-testid={`nav-group-${group.section.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="hidden lg:flex w-full items-center justify-between px-5 pt-3 pb-1 font-mono text-[9px] tracking-[0.2em] uppercase text-muted-foreground/60 hover:text-foreground transition-colors">
                {group.section}
                <PiCaretDownBold className={`text-[8px] transition-transform ${isCollapsed ? "-rotate-90" : ""}`} />
              </button>
            )}
            {group.section && <div className="lg:hidden mx-3 my-2 border-t border-border" />}
            {!isCollapsed && items.map((n) => {
              const Icon = n.icon;
              return (
                <Link
                  key={n.to}
                  to={tenantPath(n.to)}
                  aria-current={active === n.to ? "page" : undefined}
                  data-testid={`nav-${n.label.toLowerCase().replace(/[^a-z]+/g, "-").replace(/^-|-$/g, "")}`}
                  className={
                    `flex items-center gap-3 px-3 lg:px-5 h-10 text-sm transition-colors border-l-2 ${
                      active === n.to
                        ? "border-primary bg-accent text-foreground font-semibold"
                        : "border-transparent text-muted-foreground hover:bg-accent hover:text-foreground"
                    }`
                  }
                >
                  <Icon className="text-lg shrink-0" />
                  <span className="hidden lg:inline truncate">{n.label}</span>
                </Link>
              );
            })}
          </div>
        );
      })}
    </nav>
  );
}
